import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base, BREAD, error } from '@/store/base/module'

const module = {
  state: {
    defaultState: {
      searchInfo: {
        confirmed_flag: 0,
        search: '',
      },
      alerts:[],
      groupedAlerts:[],
    },

    searchInfo: {},
    alerts:[],
    groupedAlerts:[],
  },

  getters: {},

  mutations: {
    SET_GROUPED_ALERTS (state, alerts) {
      const groupedMap = new Map();
      alerts.forEach(alert => {
        const key = alert.classification_name;
        if (!groupedMap.has(key)) {
          groupedMap.set(key, {
            _display: false,
            _showAll: false,
            classification_name: key,
            alerts: []
          });
        }
        groupedMap.get(key).alerts.push(alert);
      });
      state.groupedAlerts = Array.from(groupedMap.values());
    },
  },

  actions: {
    async C00102_fetchData({ state, commit }) {
      const result = await $this.$api.postData({
        data: {
          C00102_getAlert: { api: 'T4020AlertResultService.C00102_getAlert', input: state.searchInfo },
        }
      })
      const alerts = result.C00102_getAlert.output

      state.alerts = alerts;
      commit('SET_GROUPED_ALERTS', alerts)
    },
    async C00102_updateAlert({ state, commit }, payload) {
      state.alerts = state.alerts.filter(alert => alert.alert_no !== payload.alert_no)
      state.groupedAlerts = state.groupedAlerts.map(groupedAlert => {
        return {
          ...groupedAlert,
          alerts: groupedAlert.alerts.filter(alert => alert.alert_no !== payload.alert_no)
        }
      })

      await $this.$api.postData({
        data: {
          C00102_updateAlert: { api: 'T4020AlertResultService.C00102_updateAlert', input: payload },
        }
      }, false)
    },
    async C00102_updateBatchAlert({ state, commit }, payload) {
      await $this.$api.postData({
        data: {
          C00102_updateBatchAlert: { api: 'T4020AlertResultService.C00102_updateBatchAlert', input: payload },
        }
      })
    },
  }
}

export default ObjArrUtils.merge(Base, error, BREAD, module)
